import { render, staticRenderFns } from "./StatementTab.vue?vue&type=template&id=03521492&scoped=true"
import script from "./StatementTab.vue?vue&type=script&lang=js"
export * from "./StatementTab.vue?vue&type=script&lang=js"
import style0 from "./StatementTab.vue?vue&type=style&index=0&id=03521492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03521492",
  null
  
)

export default component.exports